var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSealIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(45 10.414 14.036)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5.395 3.915L.762 7.657a.5.5 0 0 0-.186.389V17a.5.5 0 0 0 .5.5h8.637a.5.5 0 0 0 .5-.5V8.046a.5.5 0 0 0-.186-.389L5.395 3.915z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fillOpacity: 0.87,
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 1.5,
    fontWeight: 400,
    letterSpacing: 0.011,
    transform: "rotate(-90 5.573 11.609)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.892,
    y: 12.109
  }, "581950")), /*#__PURE__*/React.createElement("circle", {
    cx: 5.395,
    cy: 7.773,
    r: 1.227,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.986.07h1v6.545h-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealIcon);
export default __webpack_public_path__ + "static/media/seal_icon.726030ff5b4693b74131306fa4647ca2.svg";
export { ForwardRef as ReactComponent };